import { userRoles, ValidUserRole } from './userRoles';

export type InviteModalParams = {
  profileId: number | null;
  role: ValidUserRole | null;
};

const POSITIVE_INTEGER = /^[1-9]\d*$/;

function parseProfileId(value: string | null | undefined): number | null {
  if (!value || !POSITIVE_INTEGER.test(value)) {
    return null;
  }

  const profileId = Number(value);

  return Number.isSafeInteger(profileId) ? profileId : null;
}

function parseRole(value: string | null | undefined): ValidUserRole | null {
  if (!value || !Object.prototype.hasOwnProperty.call(userRoles, value)) {
    return null;
  }

  return value as ValidUserRole;
}

export function parseInviteModalParams(
  get: (name: string) => string | null | undefined,
): InviteModalParams {
  return {
    profileId: parseProfileId(get('profileId')),
    role: parseRole(get('role')),
  };
}
